const actions = {
  SET_STATE: 'currentObj/SET_STATE',
  CHANGE_CLAIM: 'currentObj/CHANGE_CLAIM',
  UPDATE_CLAIM: 'currentObj/UPDATE_CLAIM',
  CHANGE_POLICY: 'currentObj/CHANGE_POLICY',
  LOAD_DETAILS: 'currentObj/LOAD_DETAILS',
}

export default actions
